import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Text, DeleteIcon } from 'react-onei';

import UserContext from '../../context/UserContext';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 4rem;
  margin: 0 0.5rem;
`;

const PreviewImage = styled.img`
  height: 38px;
  width: 38px;
`;

const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const Preview = ({ indication, image, status, onClick }) => {
    const { wording } = useContext(UserContext);
    const { WLOST_113 } = wording;

    let preview = null;
    switch (status) {
        case 'last':
            const title = `${WLOST_113} ${indication}`;
            preview = (
                <>
                    <PreviewImage value={image.value} src={image.data} alt="" />
                    <DeleteButton
                        type="button"
                        id="remove-last-image"
                        onClick={onClick}
                        title={title}
                        aria-label={title}
                    >
                        <DeleteIcon size={16} />
                    </DeleteButton>
                </>
            );
            break;
        case 'previous':
            preview = <PreviewImage value={image.value} src={image.data} alt="" />;
            break;
        case 'current':
            preview = (
                <Text color="orange" bold size="l" className="waiting">
                    ?
                </Text>
            );
            break;
        default:
            break;
    }
    return (
        <Wrapper>
            {preview}
        </Wrapper>
    );
};

Preview.defaultProps = {
    image: null,
};

Preview.propTypes = {
    /** Function callback on click */
    onClick: PropTypes.func.isRequired,
    /** Object image */
    image: PropTypes.shape({
        format: PropTypes.string,
        value: PropTypes.number,
        data: PropTypes.string,
    }),
    /** String indication status */
    status: PropTypes.oneOf(['previous', 'last', 'current', 'next']).isRequired,
};

export default Preview;
